import type { FirstName, LastName, UserId } from "@inrev/common";

export const ACTIVE_AGENT_FOLLOWER_REQUIRED =
	"At least one active agent must remain as a follower.";

export type ActiveAgentPreview = {
	id: UserId;
	invitationPending?: boolean;
	firstName?: FirstName;
	lastName?: LastName;
};

/** Matches Dtos.Follower.fromAgentPreview / API Follower setupComplete. */
export const isActiveAgentPreview = (agent: ActiveAgentPreview): boolean =>
	!agent.invitationPending && !!agent.firstName && !!agent.lastName;

export const isOnlySetupCompleteFollower = (
	followers: { id: string; setupComplete: boolean }[],
	followerId: string,
) => {
	const active = followers.filter((follower) => follower.setupComplete);
	return active.length === 1 && active[0]?.id === followerId;
};

export const hasActiveAgentFollower = (
	followerIds: UserId[],
	agentPreviews: ActiveAgentPreview[],
): boolean =>
	followerIds.some((followerId) => {
		const agent = agentPreviews.find((preview) => preview.id === followerId);
		return !!agent && isActiveAgentPreview(agent);
	});
